//登録フロー・登録後身分証アップロード：身分証アップロード・登録 /newflow6
import React, { Component } from 'react';
import Header from './header'
import Footer from './footer'
import define from './define';
import {Link, browserHistory} from 'react-router';
import users from './store/user'
import FileBase64 from 'react-file-base64';
import request from 'request-promise';
import {checkLogin, TrustdockTokenregister, TrustdockIDregister} from './firebase'
import './css/signUp.css';
import $ from 'jquery';
import ToggleDisplay from 'react-toggle-display';

export default class newflow5 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLogin: false,
      files: [],
      fileUpStart: false,
      file1Up: false,
      file2Up: false,
      img1: "",
      img1_base64: "",
      img2: "",
      img2_base64: "",
      img_select: false,

      jumpURL: "/namesRegister",

      identification_kind:'drivers_license',
      identification_kind_text : {
        drivers_license:{
          text:'運転免許証',
          btn:[
            {
              required:true,
              text:'表面',
            },
            {
              required:true,
              text:'裏面'
            }
          ]
        },
        health_insurance_card:{
          text:'健康保険証',
          btn:[
            {
              required:true,
              text:'表面',
            },
            {
              required:false,
              text:'裏面'
            }
          ]
        },
        passport:{
          text:'パスポート',
          btn:[
            {
              required:true,
              text:'顔写真面',
            },
            {
              required:true,
              text:'住所面'
            }          
          ]
        }
      },
      isFront:false
    }
    //console.log(props)
  }

  componentWillMount = () => {
    this.setIdentifyKind()
  }

  setIdentifyKind = () => {
    const {
      location
    } = this.props
    if(location.state) {
      //console.log(location)
      this.setState({identification_kind:location.state.kind})
    } else {
      browserHistory.push('/newflow5')
    }
  }

  // 免許証アップロード
  getFiles = (e) => {
    const {
      isFront
    } = this.state
    //this.setState({ fileUpStart: true })
    //console.log(e)
    var files = e;
    //console.log(files);
    // stateの更新
    this.setState({ files: files })

    //if (false === this.state.img_select) {
    if(isFront) {
      //console.log('IS FRONT!!')
      // 免許証一枚目（表面）
      this.setState({img1_base64: files.base64})
      let s = files.base64.split(',');
      let img_base64 = s[1].toString();
      this.setState({img1: img_base64})    // trustdockへのデータ送信用にbase64エンコードする
      this.setState({ file1Up: true })
    } else {
      // 免許証二枚目（裏面）
      //console.log('IS BACK!!')
      this.setState({img2_base64: files.base64})
      let s = files.base64.split(',');
      let img_base64 = s[1].toString();
      this.setState({img2: img_base64})
      this.setState({ file2Up: true })
    }

    //this.setState({ fileUpStart: false })

    
  }

  // Trustdockつなぎこみ
  startTrustdock = () => {
    const {
      identification_kind,
      img1,
      img2
    } = this.state
    this.setState({ fileUpStart: true })

    //画像
    let upImageArr = []
    if(img1) upImageArr.push(img1)
    if(img2) upImageArr.push(img2)


    // オプションを定義
    var options = {
      url: define.TRUSTDOCK_CONFIG.documents_api_url,
      method: 'POST',
      headers: define.TRUSTDOCK_CONFIG.documents_api_headers,
      json: {"type": identification_kind, "images": upImageArr}
    }

    //console.log('type',options);
    
    // Trustdockにデータを送信 
    request(options, (err, res, body) => {
      if (body.token) {
        //console.log("TrustdockToken=" + body.token);
        //users.getMyUser().trustdockToken = body.token
        TrustdockTokenregister(body.token)
        users.getMyUser().trustdockId = ''
        //ログイン済（ID再登録フローの場合のみ）
        // torustdockTokenの認証作業開始
        //console.log(body.token,users.getMyUser().trustdockToken)
        if ("" !== body.token && !users.getMyUser().trustdockId/* && false === this.state.onCertificationStart*/) {
          //console.log("v3.1.0");
          //this.setState({onCertificationStart:true});

          var token = users.getMyUser().trustdockToken
          var name = users.getMyUser().displayName
          //stateconsole.log(token,name)

          // オプションを定義
          var options = {
            url: define.TRUSTDOCK_CONFIG.review_api_url,
            method: 'POST',
            headers: define.TRUSTDOCK_CONFIG.review_api_headers,
            json: {"document": {"token": token}, "comparing_data": {"fields": ["name"], "data": {"name": name}}}
          }
          //console.log('req',options);
          // Trustdockにデータを送信
          request(options, function (err, res, body) {
            //console.log(err);
            //console.log("TrustdockID=" + body.id);
            if (body.id) {
              TrustdockIDregister(body.id)
            }
          });
        }        
      }
    });

    // リクエスト投げっぱなしのまま次のページに遷移
            
    //ID再登録でなければ規約へ

    //console.log(this.state.jumpURL)
    browserHistory.push(this.state.jumpURL);
  }

  // onload
  componentDidMount() {
    var scope = this
    $("input").addClass("fileup");

    // ログインチェック
    checkLogin(true, function(isLogin){
      if (true === isLogin) {
        scope.setState({isLogin: true})
        scope.setState({jumpURL:"/newEdit"})
      }
    })
  }

  fileupClick = (e) => {
    $(".fileup")[0].click();
  }
  
  frontRegister = (e) => {
    e.preventDefault()
    let isFront = e.currentTarget.parentNode.dataset.target
    this.setState({isFront:isFront})

    //console.log('front!')
    this.fileupClick()
  }

  frontRegisterRender = () => {
    const {
      identification_kind_text,
      identification_kind,      
      file1Up
    } = this.state
    let inner = []

    if(file1Up) {
      inner.push(
        <div>
          <p className="text-center">〈{identification_kind_text[identification_kind].btn[0].text}〉</p>
          <div className="block-photo">
            <img className="photo" alt="" src={ this.state.img1_base64 ? this.state.img1_base64 : "/img/common/Identification-front.png"} onClick={this.frontRegister} />
            <div className="overlay-photo" data-target="front">
              <img className="icon-camera" alt="" src="/img/common/edit-image.svg" onClick={this.frontRegister} />
            </div>
          </div>
        </div>
      )
    } else {
      inner.push(
        <Link className="btn-save" onClick={this.frontRegister}>{identification_kind_text[identification_kind].btn[0].text}を添付</Link>
      )
    }
    return(
      <div data-target="front">
        {inner}
        <FileBase64 multiple={ false } onDone={ this.getFiles } />
      </div>
    )
  } 

  backRegister = (e) => {
    e.preventDefault()
    this.setState({isFront:false})

    //console.log('back!')
    this.fileupClick()    
  }

  backRegisterRender = () => {
    const {
      identification_kind_text,
      identification_kind,
      file2Up
    } = this.state

    //2枚目表示不要だったら下記コメントアウトを外す
    //if(!identification_kind_text[identification_kind].btn[1].required) return
    let inner = []

    if(file2Up) {
      inner.push(
        <div>
          <p className="text-center">〈{identification_kind_text[identification_kind].btn[1].text}〉</p>
          <div className="block-photo">
            <img className="photo" alt="" src={ this.state.img2_base64 ? this.state.img2_base64 : "/img/common/Identification-back.png"} onClick={this.frontRegister} />
            <div className="overlay-photo">
              <img className="icon-camera" alt="" src="/img/common/edit-image.svg" onClick={this.backRegister} />
            </div>
          </div>
        </div>
      )
    } else {
      inner.push(
        <Link className="btn-save" onClick={this.backRegister}>{identification_kind_text[identification_kind].btn[1].text}を添付</Link>
      )
    }
    return(
      <div>
        {inner}
        <FileBase64 multiple={ false } onDone={ this.getFiles } />
      </div>
    )
  }

  toNextBtn = () => {
    const {
      identification_kind_text,
      identification_kind,    
      img1,
      img2  
    } = this.state    
    if ("" !== img1 && ("" !== img2 || !identification_kind_text[identification_kind].btn[1].required)) {
      return(
        <Link className="btn-save" onClick={this.startTrustdock}>次へ</Link>
      )
    }
  }

  render() {
    const {
      identification_kind,
      identification_kind_text
    } = this.state

      return (
    
    <div id="wrapper">
      <div id="" className="wrapper-lp wrapper-newflow5">
        <Header/>
        <div className="webWrap">
          <div className="wrapCover">
            <div className="wrapCover__contentBlock clearfix">
              <div className="content-top">
                <div className="block-signUp">
                  <h1 className="title">Sign Up</h1>
                <ToggleDisplay if={!this.state.isLogin}>
                  <img className="step_icon" src="/img/common/step-5@2x.png" alt="" />
                </ToggleDisplay>
                  <img className="title_icon" src="/img/common/img_camera.png" alt="" />
                  <h2 className="subtitle">{identification_kind_text[identification_kind].text}を登録しよう！</h2>
                  { this.frontRegisterRender() }
                  { this.backRegisterRender() }
                  { this.toNextBtn() }
                </div>
              </div>
            </div>
            <Footer/>
          </div>
        </div>
      </div>
    </div>
      )

    }
}



// WEBPACK FOOTER //
// ./src/newflow5.js